import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'
import { updateFacetValues } from 'selectors/algolia2/facets'
import { getFeatureHitsPerPage, getUrlPathString, getAlgoliaQuery } from '../selectors/app'
import { generateLocationUrl } from '../helpers/url'
const mapStateToProps = createStructuredSelector({
  getHref: (state) => {
    // We want a way to create pass in PARAMS and create UNIQUE url
    return (params): string => {
      return generateLocationUrl({
        urlPathString: getUrlPathString(state),
        queryParams: { ...getAlgoliaQuery(state), ...(params || {}) }, // Params are OVERRIDES to create URL
      })
    }
  },
  hitsPerPage: getFeatureHitsPerPage,
  updateFacetValues: (state) => {
    // Availability to Add/Remove facet from a LIST
    return (facetName: string, facetValue: string) => {
      return updateFacetValues(facetName, facetValue)(state)
    }
  },
})

const mapDispatchToProps = (dispatch) => ({})

export type ConnectorProps = {
  getHref: (...args: Array<any>) => any
  hitsPerPage: number
  updateFacetValues: (...args: Array<any>) => any
}
export default connect(mapStateToProps, mapDispatchToProps) // Component Calls Connect